export default "__VITE_ASSET__85082076__"